/**
 * Created by Administrator on 2019/12/27.
 */
import mixin from "../assets/js/mixin.js";
export default {
    obj:null,
    set: async function (store,t,to={}) {
        document.title = t;
        /*城市房产android 客户端 交互*/
        let channels = ['cityhouse.mobile.android','creprice.mobile.android','cityhouse.mobile.ios','creprice.mobile.ios'];
        if (channels.indexOf(store.getters.getChannel)>-1) {
            try{
                window.action.detail(t);
            }catch(e){
                console.log(e)
            }
        }
        //民生银行
        if(store.getters.getRealChannel(false)=='cmbc.mobile.app'){
            setTitleBar({
                "title": t, // 标题名
                "leftButton": { // 左按钮
                    "exist": "true", // true:显示左按钮,false:也显示左按钮,客户端不调用左按钮的返回事件
                    "name": "返回", //  按钮的说明
                    "func": "goBackToHistory()"
                },
                "rightButton": {
                    "exist": "false" // 不显示右按钮dfff
                }
            });
        }
        //招行
        if(store.getters.getRealChannel(false)=='cmbchina.mobile.app'){
            await mixin.methods.loadScript('/static/js/cmblapi.min.js');
            cmblapi.applet({
                api: 'setAppletTitle',
                params:{
                    title:t
                },
                success:function(){},
                fail:function(res){}
            })
            console.log('设置招行标题：'+t);
        }
        //新华财经
        if(store.getters.getRealChannel(false)=='xinhuanet.fortune.mobile'){
            await mixin.methods.loadScript('/static/js/xinhua.js');
            console.log('设置标题：'+t)
            window.xinhuaCallApi('setTitle','{"title":"'+t+'"}','');
        }
        //蒙速办
        if(store.getters.getRealChannel(false)=='msb.mobile'){
            await mixin.methods.loadScript('/static/js/openjsbridge.icity.js');
            console.log('设置标题：'+t)
            iCityBridge.setTitle(t);
        }
        //云闪付
        if(store.getters.getRealChannel(false)=='unionpay.mobile'){
            await mixin.methods.loadScript('https://open.95516.com/s/open/js/upsdk.js');
            //添加返回按钮
            if(to.name=='MyHouse'){
                upsdk.pluginReady (function(){
                    upsdk.setTitleStyle({
                        backBtnVisible: '0',
                    });
                });
            }else{
                upsdk.pluginReady (function(){
                    upsdk.setTitleStyle({
                        backBtnVisible: '1',
                    });
                });
            }
            console.log('设置云闪付返回按钮：'+t);
        }



    }

}



// WEBPACK FOOTER //
// ./src/router/setTitle.js